import { Card, Col, Row, Space, Typography } from 'antd';
import type { GlobalToken } from 'antd/es/theme/interface';
import { ApartmentOutlined, AppstoreOutlined, CompassOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { PermissionButton } from '../../../components/common/PermissionButton';

const { Text } = Typography;

export type LocationsEmptyStateCardProps = {
  token: GlobalToken;
  onCreate: () => void;
};

export function LocationsEmptyStateCard({ token, onCreate }: LocationsEmptyStateCardProps) {
  return (
    <Card
      style={{
        marginBottom: 16,
        background: token.colorWarningBg,
        border: `1px solid ${token.colorWarningBorder}`,
      }}
    >
      <Row align="middle" gutter={16} style={{ marginBottom: 16 }}>
        <Col>
          <EnvironmentOutlined style={{ fontSize: 32, color: token.colorWarning }} />
        </Col>
        <Col flex={1}>
          <Typography.Title level={5} style={{ marginBottom: 4 }}>
            エリアを登録しましょう
          </Typography.Title>
          <Text type="secondary">
            エリアを登録すると、以下の機能が利用できます。
          </Text>
        </Col>
        <Col>
          <PermissionButton type="primary" onClick={onCreate} requiredPermission="manage">
            エリアを登録する
          </PermissionButton>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={8}>
          <Card size="small" style={{ height: '100%', background: token.colorBgElevated }}>
            <Space>
              <AppstoreOutlined style={{ fontSize: 20, color: token.colorPrimary }} />
              <div>
                <Text strong>設備配置管理</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  設備をエリアに紐づけて管理
                </Text>
              </div>
            </Space>
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card size="small" style={{ height: '100%', background: token.colorBgElevated }}>
            <Space>
              <ApartmentOutlined style={{ fontSize: 20, color: token.colorSuccess }} />
              <div>
                <Text strong>階層構造</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  工場→建屋→エリアを階層で整理
                </Text>
              </div>
            </Space>
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card size="small" style={{ height: '100%', background: token.colorBgElevated }}>
            <Space>
              <CompassOutlined style={{ fontSize: 20, color: token.purple }} />
              <div>
                <Text strong>マップ表示</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  工場レイアウト上で位置を視覚化
                </Text>
              </div>
            </Space>
          </Card>
        </Col>
      </Row>
    </Card>
  );
}
